import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=36faf425"
import script from "./ProductSelector.ts?vue&type=script&lang=ts&external"
export * from "./ProductSelector.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports